// components/chat/UserHistoryPanel.jsx
import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import "./UserHistoryPanel.css";

export default function UserHistoryPanel({ userId }) {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (!userId) return;

    async function loadHistory() {
      try {
        const q = query(
          collection(db, "ai_sessoes"),
          where("userId", "==", userId),
          orderBy("createdAt", "desc")
        );

        const snap = await getDocs(q);
        setHistory(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) {
        console.error("Erro ao carregar histórico:", e);
      }
    }

    loadHistory();
  }, [userId]);

  return (
    <div className="user-history-panel">
      <h3>Histórico do usuário</h3>

      {history.length === 0 && (
        <p className="empty">Nenhum histórico encontrado.</p>
      )}

      {history.map((item) => (
        <div key={item.id} className="history-card">
          <p><b>Estilo:</b> {item.papel}</p>
          <p><b>Status:</b> {item.status}</p>
          <p><b>Operador:</b> {item.operadorNome || "—"}</p>
        </div>
      ))}
    </div>
  );
}
